import { Lock, Trophy } from "lucide-react";
import UserAvatar from "@/components/ui/UserAvatar";
import { useUserDirectory } from "@/lib/userDirectory";
import { useAuth } from "@/context/AuthContext";
import { useCrmAdmin } from "@/components/crm/crmShared";
import { DSelect } from "@/components/common/DeskSelect";

/** Point 10 — « Gagné par » à la saisie : automatique = utilisateur qui saisit ; verrouillé pour les non-admins ; liste des utilisateurs pour Premier Admin / Admin. */
export default function AgentPicker({ s, set, compact = false }) {
  const { user } = useAuth();
  const isAdmin = useCrmAdmin();
  const { users, byId } = useUserDirectory();
  const current = (s.agent_id && byId[s.agent_id]) || byId[user?.id] || user;
  const name = current?.full_name || `${current?.first_name || ""} ${current?.last_name || ""}`.trim();
  return (
    <div className="flex items-center" style={{ gap: 10, padding: compact ? "6px 10px" : "9px 12px", borderRadius: 9, background: "#18181d", border: "0.5px solid #2a2a30" }} data-testid="wiz-agent-picker">
      <Trophy size={14} style={{ color: "#D99B1E", flexShrink: 0 }} />
      <UserAvatar user={current || {}} size={compact ? 22 : 28} showPopover={false} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 8.5, textTransform: "uppercase", letterSpacing: ".4px", color: "#71717c" }}>Gagné par (commercial)</div>
        {isAdmin ? (
          <DSelect value={s.agent_id || user?.id || ""} onChange={(e) => { const u = byId[e.target.value]; set(() => ({ agent_id: e.target.value, agent_name: u?.full_name || "" })); }} style={{ background: "#101013", border: "0.5px solid #3a3a42", borderRadius: 7, padding: "4px 8px", color: "#e8e8ec", fontSize: 12, width: "100%", marginTop: 2 }} data-testid="wiz-agent-select">
            {users.filter((u) => u.selectable !== false && u.status !== "deleted").map((u) => <option key={u.id} value={u.id}>{u.full_name}</option>)}
          </DSelect>
        ) : <div className="truncate" style={{ fontSize: 12.5, fontWeight: 700, color: "#f2f2f5" }} data-testid="wiz-agent-name">{name}</div>}
      </div>
      {!isAdmin && <span className="inline-flex items-center" title="Modifiable par les administrateurs seulement" style={{ gap: 4, fontSize: 10, color: "#8b8b93", border: "0.5px solid #2a2a30", borderRadius: 20, padding: "2px 8px" }} data-testid="wiz-agent-lock"><Lock size={10} /> Admins</span>}
    </div>
  );
}
